import PropTypes from 'prop-types';
import moment from 'moment';

import Box from '@mui/material/Box';
import CircleIcon from '@mui/icons-material/Circle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import {getDays} from '../../helpers/scheduling';
import './DateTabs.scss';

const getDayObjects = ({days, date}) => days.map((d, i) => {
  const selectedDayKey = date.format('ddd').toUpperCase();
  const selectedDayIndex = days.findIndex(d => d === selectedDayKey);
  const diff = (selectedDayIndex - i) * -1;
  const newDate = moment(date).add(diff, 'days');
  const formattedDay = d.charAt(0) + d.slice(1).toLowerCase();
  return {key: d, name: formattedDay, index: i, date: newDate, dayOfMonth: newDate.format('D')};
});

const DayTabs = props => {
  const {color, date, onDaySelect, tabs, days, onChange} = props;
  const day = date.format('ddd').toUpperCase();
  const dayObjects = getDayObjects({days, date});
  return (
    <Box className="DayTabs">
      <Stack direction='row' justifyContent='space-between'>
        {(dayObjects || []).map(d =>
          <Box
            key={d.key}
            className={`DayTabs__item ${d.key === day && 'DayTabs__item--active'}`}
            onClick={() => onChange(d.date)}
          >
            <Stack
              spacing={0.25}
              paddingBottom='4px !important'
              justifyContent='space-between'
            >
              <Typography
                variant='large600Tight'
                align='center'
                paddingBottom='0.25em'
                color='text.light'
              >
                {d.name}
              </Typography>

              <Typography variant='largeBold' align='center' lineHeight='normal'>
                {d.date.format('D')}
              </Typography>

              <Stack direction='row' justifyContent='center'>
                {d.key === day
                  ? <CircleIcon className="DayTabs__item-icon"/>
                  : <Box className="DayTabs__item-placeholder" />
                }
              </Stack>
            </Stack>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

DayTabs.defaultProps = {
  date: moment(),
  days: getDays(),
  color: config().colors.primary,
};

DayTabs.propTypes = {
  days: PropTypes.arrayOf(PropTypes.string),
  date: PropTypes.object, // moment.js datetime
  onChange: PropTypes.func,
};

export default DayTabs;
